export enum Platform {
    MICROSOFT = 'microsoft',
}
